import React, { useEffect, useState } from "react";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import Loader from "../../components/shared/Loader";
import { useDispatch, useSelector } from "react-redux";
import { updateMeta } from "../../store/actions/metaAction";
import { useLocation, useHistory } from "react-router-dom";
import { Col, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { getIconSrc } from "helpers/Function";

const ServiceShow = ({ match }) => {
	const {
		params: { serviceID },
	} = match;

	const location = useLocation();
	const history = useHistory();
	const dispatch = useDispatch();
	const { handleSubmit, reset, register } = useForm();
	const auth = useSelector(state => state.auth.user);

	// Read slug from URL (treat + as space just in case)
	const paramsQS = new URLSearchParams(location.search);
	const slugFromUrlRaw = paramsQS.get("slug") || "";
	const slugFromUrl = slugFromUrlRaw.replace(/\+/g, " ");

	const [loading, setLoading] = useState(true);
	const [picture, setPicture] = useState({ preview: "", filePath: "" });
	const [pictureInner, setPictureInner] = useState({
		preview: "",
		filePath: "",
	});
	const [webDesigncounterItems, setWebDesignCounterItems] = useState([]);
	const [webDesignServices, setWebDesignServices] = useState([]);
	const [marketingCountingNumbers, setMarketingCountingNumbers] = useState([]);
	const [marketingServices, setMarketingServices] = useState([]);
	const [marketingImage, setMarketingImage] = useState({
		preview: "",
		filePath: "",
	});
	const [marketingFaqs, setMarketingFaqs] = useState([]);
	const [mobileCounterItems, setMobileCounterItems] = useState([]);
	const [mobileServices, setMobileServices] = useState([]);
	const [brandingCounterItems, setBrandingCounterItems] = useState([]);
	const [brandingServices, setBrandingServices] = useState([]);
	const [uiServices, setUiServices] = useState([]);
	const [motionBlocks, setMotionBlocks] = useState([]);
	const [motionServices, setMotionServices] = useState([]);
	const [storeServices, setStoreServices] = useState([]);
	const [storeFaqs, setStoreFaqs] = useState([]);
	const [hostingBlocks, setHostingBlocks] = useState([]);
	const [hostingServices, setHostingServices] = useState([]);
	const [storeBlocks, setStoreBlocks] = useState([]);
	const [uiBlocks, setUiBlocks] = useState([]);

	// ---- Arabic-safe slug helpers ----
	const normalizeArabic = (s = "") =>
		String(s)
			.normalize("NFC")
			.replace(/[\u0640]/g, "") // tatweel
			.replace(/[\u0617-\u061A\u064B-\u0652]/g, "") // diacritics
			.replace(/[إأآا]/g, "ا")
			.replace(/ى/g, "ي")
			.replace(/ؤ/g, "و")
			.replace(/ئ/g, "ي")
			.replace(/ة/g, "ه")
			.trim();

	const makeSlug = (txt = "") =>
		normalizeArabic(txt)
			.replace(/[\s_]+/g, "-")
			.replace(/[^0-9a-z\u0600-\u06FF-]+/gi, "")
			.replace(/-+/g, "-")
			.replace(/^-|-$/g, "");

	const ensureSlugInUrl = desiredSlug => {
		if (!desiredSlug) return;
		const params = new URLSearchParams(location.search);
		const current = params.get("slug");
		if (current === desiredSlug) return;
		params.set("slug", desiredSlug);
		history.replace({
			pathname: location.pathname,
			search: `?${params.toString()}`,
		});
	};

	// Decide layout by Arabic slug (matches your list)
	const layoutBySlug = s => {
		const n = normalizeArabic(s).replace(/\s+/g, "-"); // unify to hyphens for includes

		// "تصميم المواقع"
		if (
			n.includes("تصميم-المواقع") ||
			n.includes("تصميم-مواقع") ||
			n.includes("تصميم-مواقع-الكترونية") ||
			n.includes("تصميم-موقع-الكترونية") ||
			n.includes("مواقع-الكترونية") ||
			n.includes("شركة-تصميم-مواقع") ||
			n.includes("تصميم-مواقع-الويب") ||
			n.includes("برمجة-مواقع")
		)
			return "web_design";
		// "تطبيقات جوال (أندرويد+ Ios)"
		if (
			n.includes("تطبيقات-جوال") ||
			n.includes("اندرويد") ||
			n.includes("ios") ||
			n.includes("جوال") ||
			n.includes("تطبيقات-الموبايل") ||
			n.includes("تصميم-تطبيقات") ||
			n.includes("تصميم-تطبيقات-الجوال") ||
			n.includes("شركة-تصميم-تطبيقات") ||
			n.includes("شركة-انشاء-تطبيقات") ||
			n.includes("انشاء-تطبيق-الكتروني")
		)
			return "mobile_apps";
		// "تسويق الكتروني"
		if (
			n.includes("تسويق-الكتروني") ||
			n.includes("تسويق") ||
			n.includes("التسويق-الرقمي") ||
			n.includes("التسويق-الالكتروني") ||
			n.includes("التسويق-الإلكتروني") ||
			n.includes("شركة-تسويق-الكتروني") ||
			n.includes("خدمات-التسويق-الالكتروني") ||
			n.includes("خدمة-التسويق-الالكتروني") ||
			n.includes("خدمة-التسويق-الإلكتروني")
		)
			return "digital_marketing";
		// "الهوية التجارية"
		if (
			n.includes("الهويه-التجاريه") ||
			n.includes("هوية-تجارية") ||
			n.includes("الهويه") ||
			n.includes("هوية") ||
			n.includes("هويه") ||
			n.includes("العلامة-التجارية") ||
			n.includes("علامة-تجارية") ||
			n.includes("البراندينج") ||
			n.includes("شركة-تصميم-هوية-تجارية") ||
			n.includes("شركة-تصميم-هوية-بصرية") ||
			n.includes("بناء-العلامة-التجارية") ||
			n.includes("انشاء-هوية-تجارية") ||
			n.includes("تصميم-الهوية-البصرية")
		)
			return "branding_identity";
		// "تصميم واجهات الاستخدام"
		if (
			n.includes("تصميم-واجهات-الاستخدام") ||
			n.includes("واجهات-المستخدم") ||
			n.includes("تصميم-واجهات") ||
			n.includes("تصميم-تجربة-المستخدم") ||
			n.includes("تجربة-المستخدم") ||
			n.includes("تصميم-واجهات-المستخدم") ||
			n.includes("تصميم-واجهات-تطبيق") ||
			n.includes("تصميم-تجربة-المستخدم") ||
			n.includes("تصميم-واجهات-التطبيقات") ||
			n.includes("تصميم-واجهات-تطبيق") ||
			n.includes("تصميم-واجهات-التطبيق-ui-ux") ||
			n.includes("تصميم-واجهات-المستخدم-ui-ux") ||
			n.includes("تصميم-الواجهات-ui-ux")
		)
			return "ui_design";
		// "ﺍﻟﻤﻮﺷﻦ ﺟﺮﺍﻓﻴﻚ"  (match by keywords موشن/جرافيك)
		if (
			n.includes("موشن") ||
			n.includes("جرافيك") ||
			n.includes("موشن-جرافيك") ||
			n.includes("تصميم-موشن") ||
			n.includes("تصميم-جرافيك") ||
			n.includes("تصميم-موشن-جرافيك") ||
			n.includes("الرسوم-المتحركة") ||
			n.includes("الموشن-جرافيك") ||
			n.includes("فيديو-الموشن-جرافيك") ||
			n.includes("تصميم-فيديو-موشن-جرافيك") ||
			n.includes("شركة-تصميم-موشن-جرافيك")
		)
			return "motion_graphics";
		// "متجر الكتروني"
		if (
			n.includes("متجر-الكتروني") ||
			n.includes("متجر") ||
			n.includes("متاجر") ||
			n.includes("التجارة-الالكترونية") ||
			n.includes("المتاجر-الإلكترونية") ||
			n.includes("تصميم-متاجر") ||
			n.includes("تصميم-المتاجر-الإلكترونية") ||
			n.includes("إنشاء-متاجر-إلكترونية") ||
			n.includes("انشاء-متجر-الكتروني") ||
			n.includes("تصميم-متاجر-الكترونيه") ||
			n.includes("تصميم-متجر-الكتروني") ||
			n.includes("شركة-تصميم-متاجر")
		)
			return "ecommerce";
		// "إجادة خدمات الإستضافة"
		if (
			n.includes("خدمه استضافه المواقع") ||
			n.includes("استضافه") ||
			n.includes("استضافة") ||
			n.includes("استضافه-المواقع") ||
			n.includes("استضافة-المواقع") ||
			n.includes("استضافة-مواقع") ||
			n.includes("استضافة-موقع-الكتروني") ||
			n.includes("خدمة-استضافة") ||
			n.includes("خدمة-استضافة-المواقع") ||
			n.includes("خدمات-الاستضافة") ||
			n.includes("خدمات-استضافة-المواقع") ||
			n.includes("استضافة-سيرفرات") ||
			n.includes("إستضافة")
		)
			return "hosting_services";
		return "default";
	};

	const layoutType = layoutBySlug(slugFromUrl);

	useEffect(() => {
		onStart();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [serviceID, slugFromUrl]);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: `تعديل بيانات خدمة ( ${slugFromUrl.split("-").join(" ")} )`,
				breadcrumb: "الخدمات",
				button: { show: false, text: null, link: null },
			})
		);

		// Fetch the service (include slug if present)
		axios
			.get(`${process.env.REACT_APP_API_URL}/posts/${serviceID}`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
				params: slugFromUrl ? { slug: slugFromUrl } : undefined,
			})
			.then(function (response) {
				const d = response.data?.data?.data || {};
				setPicture({ filePath: d.icon || "", preview: d.icon || "" });
				setPictureInner({
					filePath: d.image || "",
					preview: d.image || "",
				});
				reset({
					...d,
				});

				if (d.webDesigncounterItems)
					setWebDesignCounterItems(d.webDesigncounterItems);
				if (d.webDesignServices) setWebDesignServices(d.webDesignServices);
				if (d.mobileCounterItems) setMobileCounterItems(d.mobileCounterItems);
				if (d.mobileServices) setMobileServices(d.mobileServices);
				if (d.marketingCountingNumbers)
					setMarketingCountingNumbers(d.marketingCountingNumbers);
				if (d.marketingServices) setMarketingServices(d.marketingServices);
				if (d.marketingImage) setMarketingImage(d.marketingImage);
				if (d.marketingFaqs) setMarketingFaqs(d.marketingFaqs);
				if (d.brandingCounterItems)
					setBrandingCounterItems(d.brandingCounterItems);
				if (d.brandingServices) setBrandingServices(d.brandingServices);
				if (d.uiServices) setUiServices(d.uiServices);
				if (d.motionBlocks) setMotionBlocks(d.motionBlocks);
				if (d.motionServices) setMotionServices(d.motionServices);
				if (d.storeServices) setStoreServices(d.storeServices);
				if (d.storeFaqs) setStoreFaqs(d.storeFaqs);
				if (d.hostingBlocks) setHostingBlocks(d.hostingBlocks);
				if (d.hostingServices) setHostingServices(d.hostingServices);
				if (d.storeBlocks) setStoreBlocks(d.storeBlocks);
				if (d.uiBlocks) setUiBlocks(d.uiBlocks);

				// Determine final Arabic slug to show in URL
				const desiredSlug = d.title ? makeSlug(d.title) : makeSlug(d.title);
				ensureSlugInUrl(desiredSlug);

				setLoading(false);
			})
			.catch(function () {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
	};

	const uploadPicture = async (file, { silent = true } = {}) => {
		const data = new FormData();
		data.append("file", file);

		try {
			const response = await axios.post(
				`${process.env.REACT_APP_API_URL}/upload`,
				data,
				{
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
						"Content-Type": "multipart/form-data",
					},
				}
			);
			return response.data.data.filePath;
		} catch (error) {
			if (!silent) {
				// استخدمها فقط لو حابب تظهر توست عند الفشل
				toast.error("خطأ في رفع الصورة، برجاء المحاولة مرة أخرى!");
			}
			throw error; // سيب الـ onSubmit يتصرف
		}
	};

	const handlePicture = async e => {
		if (e.target.id === "picture") {
			const filePath = await uploadPicture(e.target.files[0]);
			if (!filePath) return;
			setPicture({ filePath, preview: URL.createObjectURL(e.target.files[0]) });
		}
		if (e.target.id === "pictureInner") {
			const filePath = await uploadPicture(e.target.files[0]);
			if (!filePath) return;
			setPictureInner({
				filePath,
				preview: URL.createObjectURL(e.target.files[0]),
			});
		}
		if (e.target.id === "marketingPicture") {
			const filePath = await uploadPicture(e.target.files[0]);
			if (!filePath) return;
			setMarketingImage({
				filePath,
				preview: URL.createObjectURL(e.target.files[0]),
			});
		}
	};

	const onSubmit = async formData => {
		setLoading(true);

		// helper: يرفع الـ File أو يرجع المسار لو كان string أو object{filePath}
		const resolveIcon = async icon => {
			if (!icon) return null;
			try {
				if (icon instanceof File) {
					const path = await uploadPicture(icon);
					return path;
				}
				if (typeof icon === "string") return icon;
				if (typeof icon === "object" && icon.filePath) return icon.filePath;
			} catch (e) {
				console.error("Error resolving icon:", e);
				return null;
			}
			return null;
		};

		// helper: يدمج مصفوفة نصوص من form مع state (قد تحتوي على icon كـ File أو path)
		const mergeFormArrayWithState = async (formArr = [], stateArr = []) => {
			const maxLen = Math.max((formArr || []).length, (stateArr || []).length);
			const results = await Promise.all(
				Array.from({ length: maxLen }).map(async (_, i) => {
					const textItem = (formArr && formArr[i]) || {};
					const stateItem = (stateArr && stateArr[i]) || {};
					const title = textItem.title ?? stateItem.title ?? "";
					const description =
						textItem.description ?? stateItem.description ?? "";
					const iconSource = stateItem.icon ?? textItem.icon ?? null;
					const iconPath = await resolveIcon(iconSource);

					const out = { title, description };
					if (iconPath) out.icon = iconPath;
					return out;
				})
			);
			return results;
		};

		// Helper عام للتعامل مع ملف/مسار/كائن وإرجاع مسار الرفع (string) أو null
		const resolveFilePath = async fileOrPath => {
			if (!fileOrPath) return null;

			// لو File (من input)
			if (fileOrPath instanceof File) {
				try {
					const path = await uploadPicture(fileOrPath);
					return path;
				} catch (e) {
					console.error("Upload failed:", e);
					return null;
				}
			}

			// لو جاي ككائن { filePath: '...' }
			if (typeof fileOrPath === "object" && fileOrPath.filePath) {
				return fileOrPath.filePath;
			}

			// لو string path
			if (typeof fileOrPath === "string") {
				return fileOrPath;
			}

			return null;
		};

		try {
			// --- Merge arrays that may include icons ---
			const mergedWebDesignServices = await mergeFormArrayWithState(
				formData.webDesignServices || [],
				webDesignServices || []
			);

			const mergedMarketingCountingNumbers = await mergeFormArrayWithState(
				formData.marketingCountingNumbers || [],
				marketingCountingNumbers || []
			);

			const mergedMarketingServices = await mergeFormArrayWithState(
				formData.marketingServices || [],
				marketingServices || []
			);

			const mergedHostingBlocks = await mergeFormArrayWithState(
				formData.hostingBlocks || [],
				hostingBlocks || []
			);

			const mergedStoreBlocks = await mergeFormArrayWithState(
				formData.storeBlocks || [],
				storeBlocks || []
			);

			const mergedUiBlocks = await mergeFormArrayWithState(
				formData.uiBlocks || [],
				uiBlocks || []
			);

			// --- For arrays that don't contain icons, fallback to formData or state ---
			const finalWebDesignCounterItems =
				formData.webDesigncounterItems || webDesigncounterItems || [];
			const finalMobileCounterItems =
				formData.mobileCounterItems || mobileCounterItems || [];
			const finalMobileServices =
				formData.mobileServices || mobileServices || [];
			const finalMarketingFaqs = formData.marketingFaqs || marketingFaqs || [];
			const finalBrandingCounterItems =
				formData.brandingCounterItems || brandingCounterItems || [];
			const finalBrandingServices =
				formData.brandingServices || brandingServices || [];
			const finalUiServices = formData.uiServices || uiServices || [];
			const finalMotionBlocks = formData.motionBlocks || motionBlocks || [];
			const finalMotionServices =
				formData.motionServices || motionServices || [];
			const finalStoreServices = formData.storeServices || storeServices || [];
			const finalStoreFaqs = formData.storeFaqs || storeFaqs || [];
			const finalHostingServices =
				formData.hostingServices || hostingServices || [];

			// --- Ensure main pictures are taken from state (uploaded filePath) or from formData as fallback ---
			const finalIcon = picture?.filePath || formData.icon || null;
			const finalImage = pictureInner?.filePath || formData.image || null;

			const marketingImagePath =
				(await resolveFilePath(marketingImage)) ||
				(await resolveFilePath(formData.marketingImage)) ||
				null;

			// وبعدين في payload خليه ككائن لو فيه قيمة
			const finalMarketingImage = marketingImagePath
				? { filePath: marketingImagePath }
				: null;

			// --- Build payload.data ---
			const payloadData = {
				...formData, // keep any other simple fields from form
				// replace arrays with merged/processed versions
				webDesignServices: mergedWebDesignServices,
				marketingCountingNumbers: mergedMarketingCountingNumbers,
				marketingServices: mergedMarketingServices,
				hostingBlocks: mergedHostingBlocks,
				storeBlocks: mergedStoreBlocks,
				uiBlocks: mergedUiBlocks,

				// arrays without icon handling
				webDesigncounterItems: finalWebDesignCounterItems,
				mobileCounterItems: finalMobileCounterItems,
				mobileServices: finalMobileServices,
				marketingFaqs: finalMarketingFaqs,
				brandingCounterItems: finalBrandingCounterItems,
				brandingServices: finalBrandingServices,
				uiServices: finalUiServices,
				motionBlocks: finalMotionBlocks,
				motionServices: finalMotionServices,
				storeServices: finalStoreServices,
				storeFaqs: finalStoreFaqs,
				hostingServices: finalHostingServices,

				// main images
				icon: finalIcon,
				image: finalImage,
				marketingImage: finalMarketingImage,
			};

			// debug: اطبع payload للتأكد أثناء التطوير
			// احذف أو علّق هذا السطر لاحقاً

			// --- ارسال الطلب للـ API ---
			await axios.put(
				`${process.env.REACT_APP_API_URL}/posts/${serviceID}`,
				{ category_id: 4, admin_id: auth.data.id, data: payloadData },
				{
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
					},
					params: slugFromUrl ? { slug: slugFromUrl } : undefined,
				}
			);

			toast.success("تم تحديث الخدمة بنجاح!");

			// استخدم title من formData (موثوق أكثر من متغير محلي)
			const desiredSlug = formData.title ? makeSlug(formData.title) : "";
			if (desiredSlug) ensureSlugInUrl(desiredSlug);
		} catch (err) {
			console.error("onSubmit error:", err);
			toast.error("حدث خطأ أثناء تحديث الخدمة.");
		} finally {
			setLoading(false);
		}
	};

	// ---------- Layout sections for your 8 services ----------

	const WebDesignFields = () => (
		<>
			<div className="card">
				<div className="card-header">اعدادات عامة</div>
				<div className="card-body">
					<div className="form-item mb-0">
						<label>عنوان رئيسي </label>
						<input type="text" {...register("title")} />
					</div>
				</div>
			</div>

			{/* main title section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السكشن الاول</div>
				<div className="card-body">
					<div className="form-item">
						<label>عنوان </label>
						<input type="text" {...register("web_design_sec1_title")} />
					</div>
					<div className="form-item">
						<label>وصف </label>
						<textarea {...register("web_design_sec1_description")} rows={5} />
					</div>
					<div className="card">
						<div className="d-flex align-items-center gap-3 justify-content-between card-header">
							العناصر
							<button
								type="button"
								className="btn btn-success"
								onClick={() => {
									setWebDesignCounterItems([
										...webDesigncounterItems,
										{ title: "", description: "", icon: "" },
									]);
								}}
							>
								+ اضافة
							</button>
						</div>
						{/* add dynamic items with title and description */}
						{webDesigncounterItems?.length > 0 ? (
							<div className="card-body">
								{webDesigncounterItems?.map((item, index) => (
									<div key={index} className="card mt-4 bg-body-tertiary">
										<div className="card-body">
											<div className="form-item">
												<label>عنوان </label>
												<input
													type="text"
													{...register(`webDesignCounterItems[${index}].title`)}
												/>
											</div>
											<div className="form-item">
												<label>وصف </label>
												<input
													type="text"
													{...register(
														`webDesignCounterItems[${index}].description`
													)}
												/>
											</div>
											<div className="form-item mb-0">
												<button
													type="button"
													className="btn btn-danger w-100"
													onClick={() => {
														setWebDesignCounterItems([
															...webDesigncounterItems.slice(0, index),
															...webDesigncounterItems.slice(index + 1),
														]);
													}}
												>
													- حذف
												</button>
											</div>
										</div>
									</div>
								))}
							</div>
						) : (
							<div className="card-body">
								<p className="mb-0 text-center">لا يوجد عناصر</p>
							</div>
						)}
					</div>
				</div>
			</div>

			{/* card section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السكشن الثاني</div>
				<div className="card-body">
					<div className="form-item">
						<label>عنوان </label>
						<input type="text" {...register("web_design_sec2_title")} />
					</div>
					<div className="form-item mb-0">
						<label>وصف </label>
						<textarea {...register("web_design_sec2_description")} rows={7} />
					</div>
				</div>
			</div>

			{/* services section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السكشن الثالث</div>
				<div className="card-body">
					<div className="form-item">
						<label>عنوان </label>
						<input type="text" {...register("web_design_sec3_title")} />
					</div>
					{/* add dynamic items with icon and title and description */}
					<div className="card">
						<div className="d-flex align-items-center gap-3 justify-content-between card-header">
							العناصر
							<button
								type="button"
								className="btn btn-success"
								onClick={() => {
									setWebDesignServices([
										...webDesignServices,
										{ title: "", description: "", icon: "" },
									]);
								}}
							>
								+ اضافة
							</button>
						</div>
						{webDesignServices?.length > 0 ? (
							<div className="card-body">
								{webDesignServices?.map((item, index) => (
									<div key={index} className="card mt-4 bg-body-tertiary">
										<div className="card-body">
											<div className="form-item">
												<label>ايقونة </label>
												{/* add icon path */}
												<input
													type="file"
													accept="image/*"
													onChange={e => {
														const file = e.target.files?.[0];
														if (!file) return;
														setWebDesignServices(prev =>
															prev.map((it, i) =>
																i === index ? { ...it, icon: file } : it
															)
														);
													}}
												/>

												{getIconSrc(item.icon) && (
													<img
														src={getIconSrc(item.icon)}
														alt="icon"
														style={{
															width: 80,
															height: 80,
															objectFit: "contain",
															padding: 10,
														}}
														className="imagePreview"
													/>
												)}
											</div>
											<div className="form-item">
												<label>عنوان </label>
												<input
													type="text"
													{...register(`webDesignServices[${index}].title`)}
												/>
											</div>
											<div className="form-item">
												<label>وصف </label>
												<input
													type="text"
													{...register(
														`webDesignServices[${index}].description`
													)}
												/>
											</div>
											<div className="form-item mb-0">
												<button
													type="button"
													className="btn btn-danger w-100"
													onClick={() => {
														setWebDesignServices([
															...webDesignServices.slice(0, index),
															...webDesignServices.slice(index + 1),
														]);
													}}
												>
													- حذف
												</button>
											</div>
										</div>
									</div>
								))}
							</div>
						) : (
							<div className="card-body">
								<p className="mb-0 text-center">لا يوجد عناصر</p>
							</div>
						)}
					</div>
				</div>
			</div>

			{/* clients and reviews section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السكشن الرابع</div>
				<div className="card-body">
					<div className="form-item">
						<label>عنوان </label>
						<input type="text" {...register("web_design_sec4_title")} />
					</div>
					<div className="d-flex gap-5">
						<div className="form-item mb-0">
							<label htmlFor="hide_customers">اخفاء / اظهار العملاء</label>
							<div className="form-check form-switch">
								<Form.Check
									type="switch"
									{...register("web_design_sec4_hide_customers")}
									id="hide_customers"
								/>
							</div>
						</div>
						<div className="form-item  mb-0">
							<label htmlFor="hide_reviews">اخفاء / اظهار الاراء</label>
							<div className="form-check form-switch">
								<Form.Check
									type="switch"
									{...register("web_design_sec4_hide_reviews")}
									id="hide_reviews"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* contact form section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السكشن الخامس</div>
				<div className="card-body">
					<div className="form-item">
						<label>عنوان </label>
						<input type="text" {...register("web_design_sec5_title")} />
					</div>
					<div className="form-item mb-0">
						<label>وصف </label>
						<input type="text" {...register("web_design_sec5_description")} />
					</div>
				</div>
			</div>

			{/* seo section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السيو</div>
				<div className="card-body">
					<div className="form-item">
						<label>عنوان الصفحة</label>
						<input type="text" {...register("pageTitle")} />
					</div>
					<div className="form-item">
						<label>وصف الصفحة</label>
						<textarea {...register("pageDescrition")} rows={5} />
					</div>
					<div className="form-item">
						<label>رابط الصفحة</label>
						<input type="text" {...register("pageUrl")} />
					</div>
					<div className="form-item mb-0">
						<label> الكلمات المفتاحية</label>
						<textarea {...register("pageKeyWords")} rows={5} />
					</div>
				</div>
			</div>
		</>
	);

	const MobileAppsFields = () => (
		<>
			<div className="card">
				<div className="card-header">اعدادات عامة</div>
				<div className="card-body">
					<div className="form-item mb-0">
						<label>عنوان رئيسي </label>
						<input type="text" {...register("title")} />
					</div>
				</div>
			</div>

			{/* main title section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السكشن الاول</div>
				<div className="card-body">
					<div className="form-item">
						<label>عنوان </label>
						<input type="text" {...register("mobile_sec1_title")} />
					</div>
					<div className="form-item">
						<label>وصف </label>
						<textarea {...register("mobile_sec1_description")} rows={5} />
					</div>
					<div className="card">
						<div className="d-flex align-items-center gap-3 justify-content-between card-header">
							العناصر
							<button
								type="button"
								className="btn btn-success"
								onClick={() => {
									setMobileCounterItems([
										...mobileCounterItems,
										{ title: "", description: "" },
									]);
								}}
							>
								+ اضافة
							</button>
						</div>
						{/* add dynamic items with title and description */}
						{mobileCounterItems?.length > 0 ? (
							<div className="card-body">
								{mobileCounterItems?.map((item, index) => (
									<div key={index} className="card mt-4 bg-body-tertiary">
										<div className="card-body">
											<div className="form-item">
												<label>عنوان </label>
												<input
													type="text"
													{...register(`mobileCounterItems[${index}].title`)}
												/>
											</div>
											<div className="form-item">
												<label>وصف </label>
												<input
													type="text"
													{...register(
														`mobileCounterItems[${index}].description`
													)}
												/>
											</div>
											<div className="form-item mb-0">
												<button
													type="button"
													className="btn btn-danger w-100"
													onClick={() => {
														setMobileCounterItems([
															...mobileCounterItems.slice(0, index),
															...mobileCounterItems.slice(index + 1),
														]);
													}}
												>
													- حذف
												</button>
											</div>
										</div>
									</div>
								))}
							</div>
						) : (
							<div className="card-body">
								<p className="mb-0 text-center">لا يوجد عناصر</p>
							</div>
						)}
					</div>
				</div>
			</div>

			{/* title and description section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السكشن الثاني</div>
				<div className="card-body">
					<div className="form-item">
						<label>عنوان </label>
						<textarea rows={3} {...register("mobile_sec2_title")} />
					</div>
					<div className="form-item mb-0">
						<label>وصف </label>
						<textarea {...register("mobile_sec2_description")} rows={7} />
					</div>
				</div>
			</div>

			{/* title and description section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السكشن الثالث</div>
				<div className="card-body">
					<div className="form-item">
						<label>عنوان </label>
						<input type="text" {...register("mobile_sec3_title")} />
					</div>
					<div className="form-item mb-0">
						<label>وصف </label>
						<textarea {...register("mobile_sec3_description")} rows={7} />
					</div>
				</div>
			</div>

			{/* services section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السكشن الرابع</div>
				<div className="card-body">
					<div className="form-item">
						<label>عنوان </label>
						<input type="text" {...register("mobile_sec4_title")} />
					</div>
					{/* add dynamic items with icon and title and description */}
					<div className="card">
						<div className="d-flex align-items-center gap-3 justify-content-between card-header">
							العناصر
							<button
								type="button"
								className="btn btn-success"
								onClick={() => {
									setMobileServices([
										...mobileServices,
										{ title: "", description: "" },
									]);
								}}
							>
								+ اضافة
							</button>
						</div>
						{mobileServices?.length > 0 ? (
							<div className="card-body">
								{mobileServices?.map((item, index) => (
									<div key={index} className="card mt-4 bg-body-tertiary">
										<div className="card-body">
											<div className="form-item">
												<label>عنوان </label>
												<input
													type="text"
													{...register(`mobileServices[${index}].title`)}
												/>
											</div>
											<div className="form-item">
												<label>وصف </label>
												<textarea
													rows={3}
													{...register(`mobileServices[${index}].description`)}
												/>
											</div>
											<div className="form-item mb-0">
												<button
													type="button"
													className="btn btn-danger w-100"
													onClick={() => {
														setMobileServices([
															...mobileServices.slice(0, index),
															...mobileServices.slice(index + 1),
														]);
													}}
												>
													- حذف
												</button>
											</div>
										</div>
									</div>
								))}
							</div>
						) : (
							<div className="card-body">
								<p className="mb-0 text-center">لا يوجد عناصر</p>
							</div>
						)}
					</div>
				</div>
			</div>

			{/* clients and reviews section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السكشن الخامس</div>
				<div className="card-body">
					<div className="form-item">
						<label>عنوان </label>
						<input type="text" {...register("mobile_sec5_title")} />
					</div>
					<div className="d-flex gap-5">
						<div className="form-item mb-0">
							<label htmlFor="hide_customers">اخفاء / اظهار العملاء</label>
							<div className="form-check form-switch">
								<Form.Check
									type="switch"
									{...register("mobile_sec5_hide_customers")}
									id="hide_customers"
								/>
							</div>
						</div>
						<div className="form-item  mb-0">
							<label htmlFor="hide_reviews">اخفاء / اظهار الاراء</label>
							<div className="form-check form-switch">
								<Form.Check
									type="switch"
									{...register("mobile_sec5_hide_reviews")}
									id="hide_reviews"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* contact form section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السكشن السادس</div>
				<div className="card-body">
					<div className="form-item">
						<label>عنوان </label>
						<input type="text" {...register("mobile_sec6_title")} />
					</div>
					<div className="form-item mb-0">
						<label>وصف </label>
						<input type="text" {...register("mobile_sec6_description")} />
					</div>
				</div>
			</div>

			{/* seo section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السيو</div>
				<div className="card-body">
					<div className="form-item">
						<label>عنوان الصفحة</label>
						<input type="text" {...register("pageTitle")} />
					</div>
					<div className="form-item">
						<label>وصف الصفحة</label>
						<textarea {...register("pageDescrition")} rows={5} />
					</div>
					<div className="form-item">
						<label>رابط الصفحة</label>
						<input type="text" {...register("pageUrl")} />
					</div>
					<div className="form-item mb-0">
						<label> الكلمات المفتاحية</label>
						<textarea {...register("pageKeyWords")} rows={5} />
					</div>
				</div>
			</div>
		</>
	);

	const DigitalMarketingFields = () => (
		<>
			<div className="card">
				<div className="card-header">اعدادات عامة</div>
				<div className="card-body">
					<div className="form-item mb-0">
						<label>عنوان رئيسي </label>
						<input type="text" {...register("title")} />
					</div>
				</div>
			</div>

			{/* main title section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السكشن الأول</div>
				<div className="card-body">
					<div className="form-item">
						<label>عنوان </label>
						<input type="text" {...register("marketing_sec1_title")} />
					</div>
					<div className="form-item mb-0">
						<label>وصف </label>
						<textarea {...register("marketing_sec1_description")} rows={5} />
					</div>
				</div>
			</div>

			{/* card with items section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السكشن الثاني</div>
				<div className="card-body">
					<div className="form-item">
						<label>عنوان </label>
						<input type="text" {...register("marketing_sec2_title")} />
					</div>
					<div className="form-item">
						<label>وصف </label>
						<textarea
							{...register("marketing_sec2_description")}
							rows={5}
						></textarea>
					</div>
					<div className="card">
						<div className="d-flex align-items-center gap-3 justify-content-between card-header">
							العناصر
							<button
								type="button"
								className="btn btn-success"
								onClick={() => {
									setMarketingCountingNumbers([
										...marketingCountingNumbers,
										{ title: "", description: "", icon: "" },
									]);
								}}
							>
								+ اضافة
							</button>
						</div>
						{/* add dynamic items with title and description */}
						{marketingCountingNumbers?.length > 0 ? (
							<div className="card-body">
								{marketingCountingNumbers?.map((item, index) => (
									<div key={index} className="card mt-4 bg-body-tertiary">
										<div className="card-body">
											<div className="form-item">
												<label>ايقونة </label>
												{/* add icon path */}
												<input
													type="file"
													accept="image/*"
													onChange={e => {
														const file = e.target.files?.[0];
														if (!file) return;
														setMarketingCountingNumbers(prev =>
															prev.map((it, i) =>
																i === index ? { ...it, icon: file } : it
															)
														);
													}}
												/>

												{getIconSrc(item.icon) && (
													<img
														src={getIconSrc(item.icon)}
														alt="icon"
														style={{
															width: 80,
															height: 80,
															objectFit: "contain",
															padding: 10,
														}}
														className="imagePreview"
													/>
												)}
											</div>
											<div className="form-item">
												<label>عنوان </label>
												<textarea
													rows={3}
													{...register(
														`marketingCountingNumbers[${index}].title`
													)}
												/>
											</div>

											<div className="form-item mb-0">
												<button
													type="button"
													className="btn btn-danger w-100"
													onClick={() => {
														setMarketingCountingNumbers([
															...marketingCountingNumbers.slice(0, index),
															...marketingCountingNumbers.slice(index + 1),
														]);
													}}
												>
													- حذف
												</button>
											</div>
										</div>
									</div>
								))}
							</div>
						) : (
							<div className="card-body">
								<p className="mb-0 text-center">لا يوجد عناصر</p>
							</div>
						)}
					</div>
				</div>
			</div>

			{/* section with single image left section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السكشن الثالث</div>
				<div className="card-body">
					<div className="form-item">
						<label>الصورة</label>
						<input type="file" onChange={handlePicture} id="marketingPicture" />
						{marketingImage.filePath ? (
							<img
								src={marketingImage.filePath}
								alt="avatar"
								style={{
									width: "200px",
									height: "200px",
									objectFit: "contain",
									padding: "10px",
								}}
								className="mt-3 bg-body-tertiary d-flex align-items-center justify-content-center rounded-4"
							/>
						) : null}
					</div>
					<div className="form-item">
						<label>عنوان </label>
						<input type="text" {...register("marketing_sec3_title")} />
					</div>
					<div className="form-item mb-0">
						<label>وصف </label>
						<textarea
							rows={5}
							{...register("marketing_sec3_description")}
						></textarea>
					</div>
				</div>
			</div>

			{/* services section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السكشن الرابع</div>
				<div className="card-body">
					<div className="form-item">
						<label>عنوان </label>
						<input type="text" {...register("marketing_sec4_title")} />
					</div>
					{/* add dynamic items with icon and title and description */}
					<div className="card">
						<div className="d-flex align-items-center gap-3 justify-content-between card-header">
							العناصر
							<button
								type="button"
								className="btn btn-success"
								onClick={() => {
									setMarketingServices([
										...marketingServices,
										{ title: "", description: "", icon: "" },
									]);
								}}
							>
								+ اضافة
							</button>
						</div>
						{marketingServices?.length > 0 ? (
							<div className="card-body">
								{marketingServices?.map((item, index) => (
									<div key={index} className="card mt-4 bg-body-tertiary">
										<div className="card-body">
											<div className="form-item">
												<label>ايقونة </label>
												{/* add icon path */}
												<input
													type="file"
													accept="image/*"
													onChange={e => {
														const file = e.target.files?.[0];
														if (!file) return;
														setMarketingServices(prev =>
															prev.map((it, i) =>
																i === index ? { ...it, icon: file } : it
															)
														);
													}}
												/>

												{getIconSrc(item.icon) && (
													<img
														src={getIconSrc(item.icon)}
														alt="icon"
														style={{
															width: 80,
															height: 80,
															objectFit: "contain",
															padding: 10,
														}}
														className="imagePreview"
													/>
												)}
											</div>
											<div className="form-item">
												<label>عنوان </label>
												<input
													type="text"
													{...register(`marketingServices[${index}].title`)}
												/>
											</div>
											<div className="form-item">
												<label>وصف </label>
												<textarea
													rows={5}
													{...register(
														`marketingServices[${index}].description`
													)}
												></textarea>
											</div>
											<div className="form-item mb-0">
												<button
													type="button"
													className="btn btn-danger w-100"
													onClick={() => {
														setMarketingServices([
															...marketingServices.slice(0, index),
															...marketingServices.slice(index + 1),
														]);
													}}
												>
													- حذف
												</button>
											</div>
										</div>
									</div>
								))}
							</div>
						) : (
							<div className="card-body">
								<p className="mb-0 text-center">لا يوجد عناصر</p>
							</div>
						)}
					</div>
				</div>
			</div>

			{/* clients and reviews section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السكشن الخامس</div>
				<div className="card-body">
					<div className="form-item">
						<label>عنوان </label>
						<input type="text" {...register("marketing_sec5_title")} />
					</div>
					<div className="d-flex gap-5">
						<div className="form-item mb-0">
							<label htmlFor="hide_customers">اخفاء / اظهار العملاء</label>
							<div className="form-check form-switch">
								<Form.Check
									type="switch"
									{...register("marketing_sec5_hide_customers")}
									id="hide_customers"
								/>
							</div>
						</div>
						<div className="form-item  mb-0">
							<label htmlFor="hide_reviews">اخفاء / اظهار الاراء</label>
							<div className="form-check form-switch">
								<Form.Check
									type="switch"
									{...register("marketing_sec5_hide_reviews")}
									id="hide_reviews"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* faqs section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السكشن السادس</div>
				<div className="card-body">
					<div className="form-item">
						<label>عنوان </label>
						<input type="text" {...register("marketing_sec6_title")} />
					</div>

					<div className="card">
						<div className="d-flex align-items-center gap-3 justify-content-between card-header">
							العناصر
							<button
								type="button"
								className="btn btn-success"
								onClick={() => {
									setMarketingFaqs([
										...marketingFaqs,
										{ title: "", description: "" },
									]);
								}}
							>
								+ اضافة
							</button>
						</div>
						{/* add dynamic items with title and description */}
						{marketingFaqs?.length > 0 ? (
							<div className="card-body">
								{marketingFaqs?.map((item, index) => (
									<div key={index} className="card mt-4 bg-body-tertiary">
										<div className="card-body">
											<div className="form-item">
												<label>عنوان </label>
												<input
													type="text"
													{...register(`marketingFaqs[${index}].title`)}
												/>
											</div>
											<div className="form-item">
												<label>وصف </label>
												<textarea
													rows={5}
													{...register(`marketingFaqs[${index}].description`)}
												></textarea>
											</div>
											<div className="form-item mb-0">
												<button
													type="button"
													className="btn btn-danger w-100"
													onClick={() => {
														setMarketingFaqs([
															...marketingFaqs.slice(0, index),
															...marketingFaqs.slice(index + 1),
														]);
													}}
												>
													- حذف
												</button>
											</div>
										</div>
									</div>
								))}
							</div>
						) : (
							<div className="card-body">
								<p className="mb-0 text-center">لا يوجد عناصر</p>
							</div>
						)}
					</div>
				</div>
			</div>

			{/* contact form heading section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السكشن السابع</div>
				<div className="card-body">
					<div className="form-item">
						<label>عنوان </label>
						<input type="text" {...register("marketing_sec7_title")} />
					</div>
					<div className="form-item mb-0">
						<label>وصف </label>
						<textarea
							{...register("marketing_sec7_description")}
							rows={5}
						></textarea>
					</div>
				</div>
			</div>

			{/* seo section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السيو</div>
				<div className="card-body">
					<div className="form-item">
						<label>عنوان الصفحة</label>
						<input type="text" {...register("pageTitle")} />
					</div>
					<div className="form-item">
						<label>وصف الصفحة</label>
						<textarea {...register("pageDescrition")} rows={5} />
					</div>
					<div className="form-item">
						<label>رابط الصفحة</label>
						<input type="text" {...register("pageUrl")} />
					</div>
					<div className="form-item mb-0">
						<label> الكلمات المفتاحية</label>
						<textarea {...register("pageKeyWords")} rows={5} />
					</div>
				</div>
			</div>
		</>
	);

	const BrandingIdentityFields = () => (
		<>
			<div className="card">
				<div className="card-header">اعدادات عامة</div>
				<div className="card-body">
					<div className="form-item mb-0">
						<label>عنوان رئيسي </label>
						<input type="text" {...register("title")} />
					</div>
				</div>
			</div>

			{/* main title section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السكشن الاول</div>
				<div className="card-body">
					<div className="form-item">
						<label>عنوان </label>
						<input type="text" {...register("branding_sec1_title")} />
					</div>
					<div className="form-item">
						<label>وصف </label>
						<textarea {...register("branding_sec1_description")} rows={5} />
					</div>
					<div className="card">
						<div className="d-flex align-items-center gap-3 justify-content-between card-header">
							العناصر
							<button
								type="button"
								className="btn btn-success"
								onClick={() => {
									setBrandingCounterItems([
										...brandingCounterItems,
										{ title: "", description: "" },
									]);
								}}
							>
								+ اضافة
							</button>
						</div>
						{/* add dynamic items with title and description */}
						{brandingCounterItems?.length > 0 ? (
							<div className="card-body">
								{brandingCounterItems?.map((item, index) => (
									<div key={index} className="card mt-4 bg-body-tertiary">
										<div className="card-body">
											<div className="form-item">
												<label>عنوان </label>
												<input
													type="text"
													{...register(`brandingCounterItems[${index}].title`)}
												/>
											</div>
											<div className="form-item">
												<label>وصف </label>
												<input
													type="text"
													{...register(
														`brandingCounterItems[${index}].description`
													)}
												/>
											</div>
											<div className="form-item mb-0">
												<button
													type="button"
													className="btn btn-danger w-100"
													onClick={() => {
														setBrandingCounterItems([
															...brandingCounterItems.slice(0, index),
															...brandingCounterItems.slice(index + 1),
														]);
													}}
												>
													- حذف
												</button>
											</div>
										</div>
									</div>
								))}
							</div>
						) : (
							<div className="card-body">
								<p className="mb-0 text-center">لا يوجد عناصر</p>
							</div>
						)}
					</div>
				</div>
			</div>

			{/* title and description section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السكشن الثاني</div>
				<div className="card-body">
					<div className="form-item">
						<label>عنوان </label>
						<input type="text" {...register("branding_sec2_title")} />
					</div>
					<div className="form-item mb-0">
						<label>وصف </label>
						<textarea {...register("branding_sec2_description")} rows={7} />
					</div>
				</div>
			</div>

			{/* services section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السكشن الثالث</div>
				<div className="card-body">
					<div className="form-item">
						<label>عنوان </label>
						<input type="text" {...register("branding_sec3_title")} />
					</div>
					{/* add dynamic items with icon and title and description */}
					<div className="card">
						<div className="d-flex align-items-center gap-3 justify-content-between card-header">
							العناصر
							<button
								type="button"
								className="btn btn-success"
								onClick={() => {
									setBrandingServices([
										...brandingServices,
										{ title: "", description: "" },
									]);
								}}
							>
								+ اضافة
							</button>
						</div>
						{brandingServices?.length > 0 ? (
							<div className="card-body">
								{brandingServices?.map((item, index) => (
									<div key={index} className="card mt-4 bg-body-tertiary">
										<div className="card-body">
											<div className="form-item">
												<label>عنوان </label>
												<input
													type="text"
													{...register(`brandingServices[${index}].title`)}
												/>
											</div>
											<div className="form-item">
												<label>وصف </label>
												<input
													type="text"
													{...register(
														`brandingServices[${index}].description`
													)}
												/>
											</div>
											<div className="form-item mb-0">
												<button
													type="button"
													className="btn btn-danger w-100"
													onClick={() => {
														setBrandingServices([
															...brandingServices.slice(0, index),
															...brandingServices.slice(index + 1),
														]);
													}}
												>
													- حذف
												</button>
											</div>
										</div>
									</div>
								))}
							</div>
						) : (
							<div className="card-body">
								<p className="mb-0 text-center">لا يوجد عناصر</p>
							</div>
						)}
					</div>
				</div>
			</div>

			{/* clients and reviews section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السكشن الرابع</div>
				<div className="card-body">
					<div className="form-item">
						<label>عنوان </label>
						<input type="text" {...register("branding_sec4_title")} />
					</div>
					<div className="d-flex gap-5">
						<div className="form-item mb-0">
							<label htmlFor="hide_customers">اخفاء / اظهار العملاء</label>
							<div className="form-check form-switch">
								<Form.Check
									type="switch"
									{...register("branding_sec4_hide_customers")}
									id="hide_customers"
								/>
							</div>
						</div>
						<div className="form-item  mb-0">
							<label htmlFor="hide_reviews">اخفاء / اظهار الاراء</label>
							<div className="form-check form-switch">
								<Form.Check
									type="switch"
									{...register("branding_sec4_hide_reviews")}
									id="hide_reviews"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* contact form section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السكشن الخامس</div>
				<div className="card-body">
					<div className="form-item">
						<label>عنوان </label>
						<input type="text" {...register("branding_sec5_title")} />
					</div>
					<div className="form-item mb-0">
						<label>وصف </label>
						<input type="text" {...register("branding_sec5_description")} />
					</div>
				</div>
			</div>

			{/* seo section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السيو</div>
				<div className="card-body">
					<div className="form-item">
						<label>عنوان الصفحة</label>
						<input type="text" {...register("pageTitle")} />
					</div>
					<div className="form-item">
						<label>وصف الصفحة</label>
						<textarea {...register("pageDescrition")} rows={5} />
					</div>
					<div className="form-item">
						<label>رابط الصفحة</label>
						<input type="text" {...register("pageUrl")} />
					</div>
					<div className="form-item mb-0">
						<label> الكلمات المفتاحية</label>
						<textarea {...register("pageKeyWords")} rows={5} />
					</div>
				</div>
			</div>
		</>
	);

	const UIDesignFields = () => (
		<>
			<div className="card">
				<div className="card-header">اعدادات عامة</div>
				<div className="card-body">
					<div className="form-item mb-0">
						<label>عنوان رئيسي </label>
						<input type="text" {...register("title")} />
					</div>
				</div>
			</div>

			{/* main title section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السكشن الاول</div>
				<div className="card-body">
					<div className="form-item">
						<label>عنوان </label>
						<input type="text" {...register("ui_sec1_title")} />
					</div>
					<div className="form-item mb-0">
						<label>وصف </label>
						<textarea {...register("ui_sec1_description")} rows={5} />
					</div>
				</div>
			</div>

			{/* blocks section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السكشن الثاني</div>
				<div className="card-body">
					{/* add dynamic items with icon and title and description */}
					<div className="card">
						<div className="d-flex align-items-center gap-3 justify-content-between card-header">
							العناصر
							<button
								type="button"
								className="btn btn-success"
								onClick={() => {
									setUiBlocks([...uiBlocks, { title: "", description: "" }]);
								}}
							>
								+ اضافة
							</button>
						</div>
						{uiBlocks?.length > 0 ? (
							<div className="card-body">
								{uiBlocks?.map((item, index) => (
									<div key={index} className="card mt-4 bg-body-tertiary">
										<div className="card-body">
											<div className="form-item">
												<label>عنوان </label>
												<input
													type="text"
													{...register(`uiBlocks[${index}].title`)}
												/>
											</div>
											<div className="form-item">
												<label>وصف </label>
												<input
													type="text"
													{...register(`uiBlocks[${index}].description`)}
												/>
											</div>
											<div className="form-item mb-0">
												<button
													type="button"
													className="btn btn-danger w-100"
													onClick={() => {
														setUiBlocks([
															...uiBlocks.slice(0, index),
															...uiBlocks.slice(index + 1),
														]);
													}}
												>
													- حذف
												</button>
											</div>
										</div>
									</div>
								))}
							</div>
						) : (
							<div className="card-body">
								<p className="mb-0 text-center">لا يوجد عناصر</p>
							</div>
						)}
					</div>
				</div>
			</div>

			{/* card section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السكشن الثالث</div>
				<div className="card-body">
					<div className="form-item">
						<label>عنوان </label>
						<input type="text" {...register("ui_sec3_title")} />
					</div>
					<div className="form-item mb-0">
						<label>وصف </label>
						<textarea {...register("ui_sec3_description")} rows={7} />
					</div>
				</div>
			</div>

			{/* services section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السكشن الرابع</div>
				<div className="card-body">
					<div className="form-item">
						<label>عنوان </label>
						<input type="text" {...register("ui_sec4_title")} />
					</div>
					{/* add dynamic items with icon and title and description */}
					<div className="card">
						<div className="d-flex align-items-center gap-3 justify-content-between card-header">
							العناصر
							<button
								type="button"
								className="btn btn-success"
								onClick={() => {
									setUiServices([
										...uiServices,
										{ title: "", description: "" },
									]);
								}}
							>
								+ اضافة
							</button>
						</div>
						{uiServices?.length > 0 ? (
							<div className="card-body">
								{uiServices?.map((item, index) => (
									<div key={index} className="card mt-4 bg-body-tertiary">
										<div className="card-body">
											<div className="form-item">
												<label>عنوان </label>
												<input
													type="text"
													{...register(`uiServices[${index}].title`)}
												/>
											</div>
											<div className="form-item">
												<label>وصف </label>
												<input
													type="text"
													{...register(`uiServices[${index}].description`)}
												/>
											</div>
											<div className="form-item mb-0">
												<button
													type="button"
													className="btn btn-danger w-100"
													onClick={() => {
														setMobileServices([
															...mobileServices.slice(0, index),
															...mobileServices.slice(index + 1),
														]);
													}}
												>
													- حذف
												</button>
											</div>
										</div>
									</div>
								))}
							</div>
						) : (
							<div className="card-body">
								<p className="mb-0 text-center">لا يوجد عناصر</p>
							</div>
						)}
					</div>
				</div>
			</div>

			{/* clients and reviews section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السكشن الخامس</div>
				<div className="card-body">
					<div className="form-item">
						<label>عنوان </label>
						<input type="text" {...register("ui_sec5_title")} />
					</div>
					<div className="d-flex gap-5">
						<div className="form-item mb-0">
							<label htmlFor="hide_customers">اخفاء / اظهار العملاء</label>
							<div className="form-check form-switch">
								<Form.Check
									type="switch"
									{...register("ui_sec5_hide_customers")}
									id="hide_customers"
								/>
							</div>
						</div>
						<div className="form-item  mb-0">
							<label htmlFor="hide_reviews">اخفاء / اظهار الاراء</label>
							<div className="form-check form-switch">
								<Form.Check
									type="switch"
									{...register("ui_sec5_hide_reviews")}
									id="hide_reviews"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* contact form section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السكشن السادس</div>
				<div className="card-body">
					<div className="form-item">
						<label>عنوان </label>
						<input type="text" {...register("ui_sec6_title")} />
					</div>
					<div className="form-item mb-0">
						<label>وصف </label>
						<input type="text" {...register("ui_sec6_description")} />
					</div>
				</div>
			</div>

			{/* seo section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السيو</div>
				<div className="card-body">
					<div className="form-item">
						<label>عنوان الصفحة</label>
						<input type="text" {...register("pageTitle")} />
					</div>
					<div className="form-item">
						<label>وصف الصفحة</label>
						<textarea {...register("pageDescrition")} rows={5} />
					</div>
					<div className="form-item">
						<label>رابط الصفحة</label>
						<input type="text" {...register("pageUrl")} />
					</div>
					<div className="form-item mb-0">
						<label> الكلمات المفتاحية</label>
						<textarea {...register("pageKeyWords")} rows={5} />
					</div>
				</div>
			</div>
		</>
	);

	const MotionGraphicsFields = () => (
		<>
			<div className="card">
				<div className="card-header">اعدادات عامة</div>
				<div className="card-body">
					<div className="form-item mb-0">
						<label>عنوان رئيسي </label>
						<input type="text" {...register("title")} />
					</div>
				</div>
			</div>

			{/* main title section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السكشن الاول</div>
				<div className="card-body">
					<div className="form-item">
						<label>عنوان </label>
						<input type="text" {...register("motion_sec1_title")} />
					</div>
					<div className="form-item mb-0">
						<label>وصف </label>
						<textarea {...register("motion_sec1_description")} rows={5} />
					</div>
				</div>
			</div>

			{/* blocks section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السكشن الثاني</div>
				<div className="card-body">
					{/* add dynamic items with icon and title and description */}
					<div className="card">
						<div className="d-flex align-items-center gap-3 justify-content-between card-header">
							العناصر
							<button
								type="button"
								className="btn btn-success"
								onClick={() => {
									setMotionBlocks([
										...motionBlocks,
										{ title: "", description: "" },
									]);
								}}
							>
								+ اضافة
							</button>
						</div>
						{motionBlocks?.length > 0 ? (
							<div className="card-body">
								{motionBlocks?.map((item, index) => (
									<div key={index} className="card mt-4 bg-body-tertiary">
										<div className="card-body">
											<div className="form-item">
												<label>عنوان </label>
												<input
													type="text"
													{...register(`motionBlocks[${index}].title`)}
												/>
											</div>
											<div className="form-item">
												<label>وصف </label>
												<input
													type="text"
													{...register(`motionBlocks[${index}].description`)}
												/>
											</div>
											<div className="form-item mb-0">
												<button
													type="button"
													className="btn btn-danger w-100"
													onClick={() => {
														setMotionBlocks([
															...motionBlocks.slice(0, index),
															...motionBlocks.slice(index + 1),
														]);
													}}
												>
													- حذف
												</button>
											</div>
										</div>
									</div>
								))}
							</div>
						) : (
							<div className="card-body">
								<p className="mb-0 text-center">لا يوجد عناصر</p>
							</div>
						)}
					</div>
				</div>
			</div>

			{/* services section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السكشن الثالث</div>
				<div className="card-body">
					<div className="form-item">
						<label>عنوان </label>
						<input type="text" {...register("motion_sec3_title")} />
					</div>
					{/* add dynamic items with icon and title and description */}
					<div className="card">
						<div className="d-flex align-items-center gap-3 justify-content-between card-header">
							العناصر
							<button
								type="button"
								className="btn btn-success"
								onClick={() => {
									setMotionServices([
										...motionServices,
										{ title: "", description: "" },
									]);
								}}
							>
								+ اضافة
							</button>
						</div>
						{motionServices?.length > 0 ? (
							<div className="card-body">
								{motionServices?.map((item, index) => (
									<div key={index} className="card mt-4 bg-body-tertiary">
										<div className="card-body">
											<div className="form-item">
												<label>عنوان </label>
												<input
													type="text"
													{...register(`motionServices[${index}].title`)}
												/>
											</div>
											<div className="form-item">
												<label>وصف </label>
												<input
													type="text"
													{...register(`motionServices[${index}].description`)}
												/>
											</div>
											<div className="form-item mb-0">
												<button
													type="button"
													className="btn btn-danger w-100"
													onClick={() => {
														setMotionServices([
															...motionServices.slice(0, index),
															...motionServices.slice(index + 1),
														]);
													}}
												>
													- حذف
												</button>
											</div>
										</div>
									</div>
								))}
							</div>
						) : (
							<div className="card-body">
								<p className="mb-0 text-center">لا يوجد عناصر</p>
							</div>
						)}
					</div>
				</div>
			</div>

			{/* clients and reviews section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السكشن الرابع</div>
				<div className="card-body">
					<div className="form-item">
						<label>عنوان </label>
						<input type="text" {...register("motion_sec4_title")} />
					</div>
					<div className="d-flex gap-5">
						<div className="form-item mb-0">
							<label htmlFor="hide_customers">اخفاء / اظهار العملاء</label>
							<div className="form-check form-switch">
								<Form.Check
									type="switch"
									{...register("motion_sec4_hide_customers")}
									id="hide_customers"
								/>
							</div>
						</div>
						<div className="form-item  mb-0">
							<label htmlFor="hide_reviews">اخفاء / اظهار الاراء</label>
							<div className="form-check form-switch">
								<Form.Check
									type="switch"
									{...register("motion_sec4_hide_reviews")}
									id="hide_reviews"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* contact form section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السكشن الخامس</div>
				<div className="card-body">
					<div className="form-item">
						<label>عنوان </label>
						<input type="text" {...register("motion_sec5_title")} />
					</div>
					<div className="form-item mb-0">
						<label>وصف </label>
						<input type="text" {...register("motion_sec5_description")} />
					</div>
				</div>
			</div>

			{/* seo section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السيو</div>
				<div className="card-body">
					<div className="form-item">
						<label>عنوان الصفحة</label>
						<input type="text" {...register("pageTitle")} />
					</div>
					<div className="form-item">
						<label>وصف الصفحة</label>
						<textarea {...register("pageDescrition")} rows={5} />
					</div>
					<div className="form-item">
						<label>رابط الصفحة</label>
						<input type="text" {...register("pageUrl")} />
					</div>
					<div className="form-item mb-0">
						<label> الكلمات المفتاحية</label>
						<textarea {...register("pageKeyWords")} rows={5} />
					</div>
				</div>
			</div>
		</>
	);

	const EcommerceFields = () => (
		<>
			<div className="card">
				<div className="card-header">اعدادات عامة</div>
				<div className="card-body">
					<div className="form-item mb-0">
						<label>عنوان رئيسي </label>
						<input type="text" {...register("title")} />
					</div>
				</div>
			</div>

			{/* main title section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السكشن الاول</div>
				<div className="card-body">
					<div className="form-item">
						<label>عنوان </label>
						<input type="text" {...register("store_sec1_title")} />
					</div>
					<div className="form-item">
						<label>وصف </label>
						<textarea {...register("store_sec1_description")} rows={5} />
					</div>
				</div>
			</div>

			{/* blocks section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السكشن الثاني</div>
				<div className="card-body">
					{/* add dynamic items with icon and title and description */}
					<div className="card">
						<div className="d-flex align-items-center gap-3 justify-content-between card-header">
							العناصر
							<button
								type="button"
								className="btn btn-success"
								onClick={() => {
									setStoreBlocks([
										...storeBlocks,
										{ title: "", description: "" },
									]);
								}}
							>
								+ اضافة
							</button>
						</div>
						{storeBlocks?.length > 0 ? (
							<div className="card-body">
								{storeBlocks?.map((item, index) => (
									<div key={index} className="card mt-4 bg-body-tertiary">
										<div className="card-body">
											<div className="form-item">
												<label>عنوان </label>
												<input
													type="text"
													{...register(`storeBlocks[${index}].title`)}
												/>
											</div>
											<div className="form-item">
												<label>وصف </label>
												<input
													type="text"
													{...register(`storeBlocks[${index}].description`)}
												/>
											</div>
											<div className="form-item mb-0">
												<button
													type="button"
													className="btn btn-danger w-100"
													onClick={() => {
														setStoreBlocks([
															...storeBlocks.slice(0, index),
															...storeBlocks.slice(index + 1),
														]);
													}}
												>
													- حذف
												</button>
											</div>
										</div>
									</div>
								))}
							</div>
						) : (
							<div className="card-body">
								<p className="mb-0 text-center">لا يوجد عناصر</p>
							</div>
						)}
					</div>
				</div>
			</div>

			{/* card section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السكشن الثالث</div>
				<div className="card-body">
					<div className="form-item">
						<label>عنوان </label>
						<input type="text" {...register("store_sec3_title")} />
					</div>
					<div className="form-item mb-0">
						<label>وصف </label>
						<textarea {...register("store_sec3_description")} rows={7} />
					</div>
				</div>
			</div>

			{/* services section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السكشن الرابع</div>
				<div className="card-body">
					<div className="form-item">
						<label>عنوان </label>
						<input type="text" {...register("store_sec4_title")} />
					</div>
					{/* add dynamic items with icon and title and description */}
					<div className="card">
						<div className="d-flex align-items-center gap-3 justify-content-between card-header">
							العناصر
							<button
								type="button"
								className="btn btn-success"
								onClick={() => {
									setStoreServices([
										...storeServices,
										{ title: "", description: "" },
									]);
								}}
							>
								+ اضافة
							</button>
						</div>
						{storeServices?.length > 0 ? (
							<div className="card-body">
								{storeServices?.map((item, index) => (
									<div key={index} className="card mt-4 bg-body-tertiary">
										<div className="card-body">
											<div className="form-item">
												<label>عنوان </label>
												<input
													type="text"
													{...register(`storeServices[${index}].title`)}
												/>
											</div>
											<div className="form-item">
												<label>وصف </label>
												<input
													type="text"
													{...register(`storeServices[${index}].description`)}
												/>
											</div>
											<div className="form-item mb-0">
												<button
													type="button"
													className="btn btn-danger w-100"
													onClick={() => {
														setStoreServices([
															...storeServices.slice(0, index),
															...storeServices.slice(index + 1),
														]);
													}}
												>
													- حذف
												</button>
											</div>
										</div>
									</div>
								))}
							</div>
						) : (
							<div className="card-body">
								<p className="mb-0 text-center">لا يوجد عناصر</p>
							</div>
						)}
					</div>
				</div>
			</div>

			{/* clients and reviews section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السكشن الخامس</div>
				<div className="card-body">
					<div className="form-item">
						<label>عنوان </label>
						<input type="text" {...register("store_sec5_title")} />
					</div>
					<div className="d-flex gap-5">
						<div className="form-item mb-0">
							<label htmlFor="hide_customers">اخفاء / اظهار العملاء</label>
							<div className="form-check form-switch">
								<Form.Check
									type="switch"
									{...register("store_sec5_hide_customers")}
									id="hide_customers"
								/>
							</div>
						</div>
						<div className="form-item  mb-0">
							<label htmlFor="hide_reviews">اخفاء / اظهار الاراء</label>
							<div className="form-check form-switch">
								<Form.Check
									type="switch"
									{...register("store_sec5_hide_reviews")}
									id="hide_reviews"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* faqs section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السكشن السادس</div>
				<div className="card-body">
					<div className="form-item">
						<label>عنوان </label>
						<input type="text" {...register("store_sec6_title")} />
					</div>

					<div className="card">
						<div className="d-flex align-items-center gap-3 justify-content-between card-header">
							العناصر
							<button
								type="button"
								className="btn btn-success"
								onClick={() => {
									setStoreFaqs([...storeFaqs, { title: "", description: "" }]);
								}}
							>
								+ اضافة
							</button>
						</div>
						{/* add dynamic items with title and description */}
						{storeFaqs?.length > 0 ? (
							<div className="card-body">
								{storeFaqs?.map((item, index) => (
									<div key={index} className="card mt-4 bg-body-tertiary">
										<div className="card-body">
											<div className="form-item">
												<label>عنوان </label>
												<input
													type="text"
													{...register(`storeFaqs[${index}].title`)}
												/>
											</div>
											<div className="form-item">
												<label>وصف </label>
												<textarea
													rows={3}
													{...register(`storeFaqs[${index}].description`)}
												/>
											</div>
											<div className="form-item mb-0">
												<button
													type="button"
													className="btn btn-danger w-100"
													onClick={() => {
														setStoreFaqs([
															...storeFaqs.slice(0, index),
															...storeFaqs.slice(index + 1),
														]);
													}}
												>
													- حذف
												</button>
											</div>
										</div>
									</div>
								))}
							</div>
						) : (
							<div className="card-body">
								<p className="mb-0 text-center">لا يوجد عناصر</p>
							</div>
						)}
					</div>
				</div>
			</div>

			{/* contact form section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السكشن السابع</div>
				<div className="card-body">
					<div className="form-item">
						<label>عنوان </label>
						<input type="text" {...register("store_sec7_title")} />
					</div>
					<div className="form-item mb-0">
						<label>وصف </label>
						<input type="text" {...register("store_sec7_description")} />
					</div>
				</div>
			</div>

			{/* seo section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السيو</div>
				<div className="card-body">
					<div className="form-item">
						<label>عنوان الصفحة</label>
						<input type="text" {...register("pageTitle")} />
					</div>
					<div className="form-item">
						<label>وصف الصفحة</label>
						<textarea {...register("pageDescrition")} rows={5} />
					</div>
					<div className="form-item">
						<label>رابط الصفحة</label>
						<input type="text" {...register("pageUrl")} />
					</div>
					<div className="form-item mb-0">
						<label> الكلمات المفتاحية</label>
						<textarea {...register("pageKeyWords")} rows={5} />
					</div>
				</div>
			</div>
		</>
	);

	const HostingFields = () => (
		<>
			<div className="card">
				<div className="card-header">اعدادات عامة</div>
				<div className="card-body">
					<div className="form-item mb-0">
						<label>عنوان رئيسي </label>
						<input type="text" {...register("title")} />
					</div>
				</div>
			</div>

			{/* main title section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السكشن الاول</div>
				<div className="card-body">
					<div className="form-item">
						<label>عنوان </label>
						<input type="text" {...register("hosting_sec1_title")} />
					</div>
					<div className="form-item mb-0">
						<label>وصف </label>
						<textarea {...register("hosting_sec1_description")} rows={5} />
					</div>
				</div>
			</div>

			{/* blocks section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السكشن الثاني</div>
				<div className="card-body">
					{/* add dynamic items with icon and title and description */}
					<div className="card">
						<div className="d-flex align-items-center gap-3 justify-content-between card-header">
							العناصر
							<button
								type="button"
								className="btn btn-success"
								onClick={() => {
									setHostingBlocks([
										...hostingBlocks,
										{ title: "", description: "" },
									]);
								}}
							>
								+ اضافة
							</button>
						</div>
						{hostingBlocks?.length > 0 ? (
							<div className="card-body">
								{hostingBlocks?.map((item, index) => (
									<div key={index} className="card mt-4 bg-body-tertiary">
										<div className="card-body">
											<div className="form-item">
												<label>عنوان </label>
												<input
													type="text"
													{...register(`hostingBlocks[${index}].title`)}
												/>
											</div>
											<div className="form-item">
												<label>وصف </label>
												<input
													type="text"
													{...register(`hostingBlocks[${index}].description`)}
												/>
											</div>
											<div className="form-item mb-0">
												<button
													type="button"
													className="btn btn-danger w-100"
													onClick={() => {
														setHostingBlocks([
															...hostingBlocks.slice(0, index),
															...hostingBlocks.slice(index + 1),
														]);
													}}
												>
													- حذف
												</button>
											</div>
										</div>
									</div>
								))}
							</div>
						) : (
							<div className="card-body">
								<p className="mb-0 text-center">لا يوجد عناصر</p>
							</div>
						)}
					</div>
				</div>
			</div>

			{/* card section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السكشن الثالث</div>
				<div className="card-body">
					<div className="form-item">
						<label>عنوان </label>
						<input type="text" {...register("hosting_sec3_title")} />
					</div>
					<div className="form-item mb-0">
						<label>وصف </label>
						<textarea {...register("hosting_sec3_description")} rows={7} />
					</div>
				</div>
			</div>

			{/* services section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السكشن الرابع</div>
				<div className="card-body">
					<div className="form-item">
						<label>عنوان </label>
						<input type="text" {...register("hosting_sec4_title")} />
					</div>
					{/* add dynamic items with icon and title and description */}
					<div className="card">
						<div className="d-flex align-items-center gap-3 justify-content-between card-header">
							العناصر
							<button
								type="button"
								className="btn btn-success"
								onClick={() => {
									setHostingServices([
										...hostingServices,
										{ title: "", description: "" },
									]);
								}}
							>
								+ اضافة
							</button>
						</div>
						{hostingServices?.length > 0 ? (
							<div className="card-body">
								{hostingServices?.map((item, index) => (
									<div key={index} className="card mt-4 bg-body-tertiary">
										<div className="card-body">
											<div className="form-item">
												<label>عنوان </label>
												<input
													type="text"
													{...register(`hostingServices[${index}].title`)}
												/>
											</div>
											<div className="form-item">
												<label>وصف </label>
												<input
													type="text"
													{...register(`hostingServices[${index}].description`)}
												/>
											</div>
											<div className="form-item mb-0">
												<button
													type="button"
													className="btn btn-danger w-100"
													onClick={() => {
														setHostingServices([
															...hostingServices.slice(0, index),
															...hostingServices.slice(index + 1),
														]);
													}}
												>
													- حذف
												</button>
											</div>
										</div>
									</div>
								))}
							</div>
						) : (
							<div className="card-body">
								<p className="mb-0 text-center">لا يوجد عناصر</p>
							</div>
						)}
					</div>
				</div>
			</div>

			{/* clients and reviews section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السكشن الخامس</div>
				<div className="card-body">
					<div className="form-item">
						<label>عنوان </label>
						<input type="text" {...register("hosting_sec5_title")} />
					</div>
					<div className="d-flex gap-5">
						<div className="form-item mb-0">
							<label htmlFor="hide_customers">اخفاء / اظهار العملاء</label>
							<div className="form-check form-switch">
								<Form.Check
									type="switch"
									{...register("hosting_sec5_hide_customers")}
									id="hide_customers"
								/>
							</div>
						</div>
						<div className="form-item  mb-0">
							<label htmlFor="hide_reviews">اخفاء / اظهار الاراء</label>
							<div className="form-check form-switch">
								<Form.Check
									type="switch"
									{...register("hosting_sec5_hide_reviews")}
									id="hide_reviews"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* contact form section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السكشن السادس</div>
				<div className="card-body">
					<div className="form-item">
						<label>عنوان </label>
						<input type="text" {...register("hosting_sec6_title")} />
					</div>
					<div className="form-item mb-0">
						<label>وصف </label>
						<input type="text" {...register("hosting_sec6_description")} />
					</div>
				</div>
			</div>

			{/* seo section */}
			<div className="card mt-3">
				<div className="card-header">اعدادات السيو</div>
				<div className="card-body">
					<div className="form-item">
						<label>عنوان الصفحة</label>
						<input type="text" {...register("pageTitle")} />
					</div>
					<div className="form-item">
						<label>وصف الصفحة</label>
						<textarea {...register("pageDescrition")} rows={5} />
					</div>
					<div className="form-item">
						<label>رابط الصفحة</label>
						<input type="text" {...register("pageUrl")} />
					</div>
					<div className="form-item mb-0">
						<label> الكلمات المفتاحية</label>
						<textarea {...register("pageKeyWords")} rows={5} />
					</div>
				</div>
			</div>
		</>
	);

	const DefaultFields = () => null;

	const renderServiceSpecific = () => {
		switch (layoutType) {
			case "web_design":
				return <WebDesignFields />;
			case "mobile_apps":
				return <MobileAppsFields />;
			case "digital_marketing":
				return <DigitalMarketingFields />;
			case "branding_identity":
				return <BrandingIdentityFields />;
			case "ui_design":
				return <UIDesignFields />;
			case "motion_graphics":
				return <MotionGraphicsFields />;
			case "ecommerce":
				return <EcommerceFields />;
			case "hosting_services":
				return <HostingFields />;
			default:
				return <DefaultFields />;
		}
	};

	return (
		<section>
			{loading && <Loader />}
			<form onSubmit={handleSubmit(onSubmit)}>
				<Row>
					<Col xxl={8} lg={8} md={9} xs={12}>
						{renderServiceSpecific()}
					</Col>

					<Col xxl={4} lg={4} md={3} xs={12}>
						<div
							className="card"
							style={{
								position: "sticky",
								top: "20px",
							}}
						>
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="picture">ايقونة الخدمة</label>
									<input type="file" onChange={handlePicture} id="picture" />
									{picture.preview ? (
										<img
											src={picture.preview}
											alt="avatar"
											className="imagePreview"
											style={{
												width: "100px",
												height: "100px",
												objectFit: "contain",
												padding: "10px",
											}}
										/>
									) : null}
								</div>

								{/*<div className="form-item">
									<label htmlFor="pictureInner">الصوره الداخلية للخدمة</label>
									<input
										type="file"
										onChange={handlePicture}
										id="pictureInner"
									/>
									{pictureInner.preview ? (
										<img
											src={pictureInner.preview}
											alt="avatar"
											className="imagePreview"
											style={{
												objectFit: "contain",
												padding: "10px",
											}}
										/>
									) : null}
								</div>*/}
								<div className="form-item my-0">
									<button className="bt bt-success btn-block" type="submit">
										ارسال
									</button>
								</div>
							</div>
						</div>
					</Col>
				</Row>
			</form>
		</section>
	);
};

export default ServiceShow;
